import React, { useState } from 'react';
import { useWallet } from '../contexts/WalletContext';
import { useNotification } from '../contexts/NotificationContext';
import WalletInstallGuide from './WalletInstallGuide';

const WalletSelectionModal = ({ onClose }) => {
  const { wallet, connect, connecting, adapterVerified } = useWallet();
  const { notifyError, notifyWarning } = useNotification();
  const [selectedWallet, setSelectedWallet] = useState(null);
  const [showInstallGuide, setShowInstallGuide] = useState(false);

  const availableWallets = [
    {
      id: 'miden',
      name: 'Miden Wallet',
      description: 'Official Miden Wallet Browser Extension',
      icon: (
        <img 
          src="data:image/png;base64,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" 
          alt="Miden Wallet icon"
          width={48}
          height={48}
          style={{ display: 'block' }}
        />
      ),
      available: !!wallet && adapterVerified,
      verified: adapterVerified,
      installUrl: 'https://chrome.google.com/webstore/category/extensions'
    }
    // Future wallets can be added here:
    // {
    //   id: 'walletconnect',
    //   name: 'WalletConnect',
    //   description: 'Connect with WalletConnect',
    //   icon: <svg>...</svg>,
    //   available: !!walletConnectProvider,
    //   installUrl: null // No install needed for WalletConnect
    // }
  ];

  const handleWalletSelect = async (walletId) => {
    setSelectedWallet(walletId);
    
    if (walletId === 'miden') {
      // Guard: only attempt connect if adapter is really there and verified
      if (!wallet || !adapterVerified) {
        console.warn('[WALLET] No verified Miden adapter available in this browser');
        notifyError(
          'Wallet Not Available',
          'Please open Miden Hub from a supported browser with the Miden Wallet extension installed, or use your wallet\'s in-app browser.',
          8000
        );
        return;
      }

      try {
        await connect(true); // user-initiated connect
        onClose();           // only close on success
      } catch (err) {
        console.warn('[WALLET] Connect failed from modal:', err);
        
        const errorMessage = err.message || 'Unable to connect to wallet. Please try again.';
        const lowerMessage = errorMessage.toLowerCase();
        
        /**
         * Error handling with three main classes:
         * 1. Unsupported environment - Shows guidance for desktop browser or in-app browser
         * 2. User explicitly cancelled - Shows "cancelled" warning, allows retry
         * 3. Technical failure - Shows error with suggestion to check extension, allows retry
         */
        
        // Class 1: Unsupported environment
        if (lowerMessage.includes('not available in this browser') || 
            lowerMessage.includes('unsupported') ||
            lowerMessage.includes('desktop chromium browser')) {
          notifyError(
            'Browser Not Supported',
            'Miden Wallet is not available in this browser. Please use a desktop Chromium browser with the Miden Wallet extension, or open Miden Hub from your wallet\'s in-app browser.',
            8000
          );
        }
        // Class 2: User explicitly cancelled
        else if (lowerMessage.includes('cancelled') || 
                 lowerMessage.includes('user rejected') ||
                 err.code === 'USER_REJECTED') {
          notifyWarning(
            'Connection Cancelled',
            'Wallet connection was cancelled. Click Connect again when you\'re ready.',
            5000
          );
        }
        // Class 3: Technical failure
        else if (lowerMessage.includes('did not return an account') ||
                 lowerMessage.includes('not available') ||
                 lowerMessage.includes('extension')) {
          notifyError(
            'Connection Failed',
            'Unable to connect to wallet. Please check that the Miden Wallet extension is installed and unlocked, then try again.',
            7000
          );
        }
        // Generic error fallback
        else {
          notifyError(
            'Connection Failed',
            errorMessage,
            6000
          );
        }
        // Keep modal open so user can retry or switch device/browser
      }
    }
    // Future wallets: add similar guarded logic here
  };

  const handleInstallClick = () => {
    window.open('https://chromewebstore.google.com/detail/miden-wallet/ablmompanofnodfdkgchkpmphailefpb', '_blank');
  };

  return (
    <div className="wallet-modal-overlay" onClick={onClose}>
      <div className="wallet-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="wallet-modal-header">
          <h2>Connect Wallet</h2>
          <button className="wallet-modal-close" onClick={onClose}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" strokeWidth="2"/>
              <line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" strokeWidth="2"/>
            </svg>
          </button>
        </div>

        <p className="wallet-modal-subtitle">
          Choose your preferred wallet to connect to Miden Hub
        </p>

        <div className="wallet-options-grid">
          {availableWallets.map((walletOption) => (
            <div 
              key={walletOption.id}
              className={`wallet-option ${!walletOption.available ? 'unavailable' : ''} ${selectedWallet === walletOption.id && connecting ? 'connecting' : ''}`}
              >
              <button
                className="wallet-option-button"
                onClick={() => walletOption.available ? handleWalletSelect(walletOption.id) : handleInstallClick(walletOption.installUrl)}
                type="button"
              >
                <div className="wallet-option-icon">
                  {walletOption.icon}
                </div>
                <div className="wallet-option-info">
                  <h3>
                    {walletOption.name}
                    {walletOption.verified && (
                      <span className="verified-badge" title="Adapter verified">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                          <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2"/>
                          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                        </svg>
                      </span>
                    )}
                  </h3>
                  <p>{walletOption.description}</p>
                  {walletOption.verified && (
                    <p className="security-status">Adapter verified for security</p>
                  )}
                </div>
                {!walletOption.available ? (
                  <div className="wallet-option-action">
                    <span className="install-badge">Install</span>
                  </div>
                ) : connecting && selectedWallet === walletOption.id ? (
                  <div className="wallet-option-action">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="spinner">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" opacity="0.3"/>
                      <path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                        <animateTransform attributeName="transform" type="rotate" dur="1s" repeatCount="indefinite" values="0 12 12;360 12 12"/>
                      </path>
                    </svg>
                  </div>
                ) : (
                  <div className="wallet-option-action">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2"/>
                    </svg>
                  </div>
                )}
              </button>
            </div>
          ))}
        </div>

        <div className="wallet-modal-footer">
          <p className="wallet-modal-help">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
              <path d="M12 16v-4" stroke="currentColor" strokeWidth="2"/>
              <path d="M12 8h.01" stroke="currentColor" strokeWidth="2"/>
            </svg>
            New to Miden? The install guide shows step-by-step instructions.
          </p>
        </div>
      </div>

      {/* Install Guide Modal */}
      {showInstallGuide && (
        <WalletInstallGuide onClose={() => setShowInstallGuide(false)} />
      )}
    </div>
  );
};

export default WalletSelectionModal;

